// Import external
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Import internal
import { SharedModule } from '@shared/shared.module';
import { MainLayoutComponent } from './main-layout.component';
import { NotificationComponent } from './notification/notification.component';

// Module
@NgModule({
    declarations: [
        MainLayoutComponent,
        NotificationComponent
    ],
    imports: [
        SharedModule,
        CommonModule,
        RouterModule,
    ],
    providers: [
    ]
})
export class MainLayoutModule {
}
